module.exports = __webpack_public_path__ + "static/media/Conexao-formacDeProf-med.6ab24acc.png";